import React from "react";
import { useParams } from 'react-router';

//import { observabel, action, toJS } from "mobx";
import { toJS } from 'mobx';
import { observer } from "mobx-react-lite";
import { TextField, Button, Typography, IconButton, Checkbox, 
         Tooltip, Switch, Slider } from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { red, blue } from '@material-ui/core/colors';
import { ArrowUpward, ArrowDownward, Delete, ExpandMore,
         ExpandLess, ExitToApp, Settings, Gavel, Subject, Create, BubbleChart,
         CheckCircle, Error, } from '@material-ui/icons';
//import { makeStyles } from '@material-ui/core/styles';

import ContentEditable from 'react-contenteditable';
//import { parseISO, format } from 'date-fns';
//import styled from 'styled-components';
import {Editor, EditorState, getDefaultKeyBinding,
        RichUtils } from 'draft-js';

import { claimTemplate, wdTemplate, drawingTemplate } from './Templates';
import { connect, socketURL, DefaultSocketURL } from './socket';
import { decorator, styles, } from './Decoration';
import { toggleComment, } from './CGModel';
import { FileMenu, signOut, } from './GDrivePicker';
import { Login } from './Login';
import { workshop } from './index';

import logo  from './logo.png';

import 'draft-js/dist/Draft.css';
import './App.css';

//const workshop = new ClaimWorkShop();
//workshop.loadExample(1);
//window.model = workshop;

connect(DefaultSocketURL);

// Fire off alice request on these keycodes
//const AliceKeyCodes = ['Tab', 'Space', 'Enter', 'Delete', 'Backspace'];
const AliceKeyCodes = ['Tab', 'Space', 'Enter', ];


const theme = createMuiTheme({
  palette: {
    primary: { main: blue[800] }, 
    secondary: { main: red[800] },
  },
  typography: { body2: { fontSize: '0.8em'} },
  //typography: { fontSize: '14pt' },
  props: {
    MuiButton: {
      variant: 'text',
      //size: 'small',
    },
    MuiTextField: {
      variant: 'outlined',
      margin: 'dense',
      size: 'small',
    },
    MuiMenuItem: {
      dense: false,
    },
    MuiTypography: {
      variantMapping: {
        h1: 'h1',
        h2: 'h1',
        h3: 'h1',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
        subtitle1: 'h2',
        subtitle2: 'h2',
        body1: 'span',
        body2: 'span',
      },
    },
  },
  overrides: {
    //MuiTypographyBody2: {
    //  root: { fontSize: '0.5em'},
    //},
    MuiButton: {
      root: { margin: "0.2em", fontSize: '0.9em'},
    },
    MuiDialogTitle: {
      root: { fontSize: "1.0em", padding: "1em 1em 0" }
    },
    MuiDialogContent: {
      root: { fontSize: "0.9em" }
    },
    MuiTextField: {
      root: { fontSize: "0.9em" }
    },
    MuiMenuItem: {
      root: { fontSize: "1.0em" }
    },
    //MuiInputLabel: {
    //  root: { fontSize: "1.0em" }
    //},
   // MuiIconButton: {
   //   root: { width: 10, height: 10 }
   // },

    // MuiInputLabel: {
    //   root: {
    //     //fontSize: 40,
    //     color: 'blue',
    //     //'&.hover': { backgroundColor: 'purple' },
    //   },
    //   shrink: {
    //     color: 'black',
    //   }
    // },
    //MuiTabs: {
    //  root: { border: '1px solid red'}
    //},
    MuiTab: {
      root: { fontSize: "14pt", flexGrow: 0, width: "10%", minWidth: "10%" }
    },
    // MuiAppBar: {
    //   root: { width: "30vw" }
    // },
  }
});
 
const rawContent = {
  blocks: [
    {
      text: (
        'for packing a lunch, comprising:'
     ),
      type: 'unstyled',
      entityRanges: [{offset: 4, length: 15, key: 'first'},],
    },
    {
      text: (
        'making a sandwich with bread and cheese'
     ),
      type: 'unordered-list-item', level:1,
      entityRanges: [{offset: 0, length: 17, key: 'foobar'},]
                     //{offset: 9, length: 8, key: 'second'}],
    },
    {
      text: (
        'selecting a fruit "In some embodiments, selecting a fruit includes picking the fruit from a tree"'
     ),
      type: 'unordered-list-item', level:1,
      entityRanges: [{offset: 0, length: 17, key: 'third'},
                     {offset: 40, length: 17, key: 'third'}],
    },
    {
      text: (
        'choosing a treat'
     ),
      type: 'unordered-list-item', level:1,
      entityRanges: [{offset: 0, length: 16, key: 'fourth'},],

    },
  ],

  entityMap: {
    first: {
      type: 'TOKEN',
      mutability: 'MUTABLE',
    },
    second: {
      type: 'TOKEN',
      mutability: 'MUTABLE',
    },
    third: {
      type: 'TOKEN',
      mutability: 'MUTABLE',
    },
    fourth: {
      type: 'TOKEN',
      mutability: 'MUTABLE',
    },
    foobar: {type: 'TOKEN', mutability: 'MUTABLE',}
  }
};


const ClaimEditor = observer(({parent, claim}) => {

  const onChange = (editorState) => {
    //console.log('ONCHANGE');
    //console.log('ED', convertToRaw(editorState.getCurrentContent()));
    claim.updateEditorState(editorState);
    //this.setState(prevState => ({editorState}));
  };

  const filterEntities = () => {
    const selection = claim.editorState.getSelection();
    const content = claim.editorState.getCurrentContent();
    const block = content.getBlockForKey(selection.getAnchorKey());
    const text = block.getText();
    let start = text.indexOf('@');
    if (start === -1) return null;
    const end = selection.getEndOffset();
    return workshop.claimSet.filterEntities(text.slice(start+1, end));
  };

  const handleBefore = (chars, editorState, time) => {
    const ek = claim.getEntityAtSelection();
    // cannot type in an entity
    if (ek) return 'handled';
    //console.log('**********', editorState, chars);
    return workshop.claimSet.addInlineEntity(claim, editorState, chars);
  }; 

  const handleKeyCommand = (command, editorState) => {
    //console.log('Command', command);
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      onChange(newState);
      return true;
    }
    return false;
  };
  
  const mapKeyToEditorCommand = (e) => {
    //console.log(e);
    if (AliceKeyCodes.includes(e.code) && workshop.claimSet.children.length) {
      workshop.claimSet.children[0].getAliceScoreFromServer(true);
    }
    if (e.keyCode === 9 /* TAB */) {
      const currentBlockType = RichUtils.getCurrentBlockType(claim.editorState);
      if (currentBlockType === 'unordered-list-item') {
        onChange(RichUtils.onTab(e, claim.editorState, 4));
      }
      else {
        onChange(RichUtils.toggleBlockType(claim.editorState, 'unordered-list-item'));
      }
      return false;
    }
    return getDefaultKeyBinding(e);
  };

  const firstWord = () => {
    let firstWord = 'The';
    if (claim.claimType === 'ind')  {
      firstWord = 'A';
      const vowels = 'AaEeIiOoUu';
      if (vowels.indexOf(claim.claimClass[0]) !== -1)
        firstWord = 'An';
    }
    return firstWord;
  };

  const headerButtons = () => {
    return (
      <span style={{display: 'flex'}}>
        <Tooltip title='New "further comprising" dependent claim.'>
          <Button style={{margin: 0, padding: 0}} size="small" 
                  onClick={(e) => {
                    claim.addChild(EditorState.createEmpty(decorator), 'dep/fc', claim.claimClass, '', false);
                  }}
          >+FC</Button>
        </Tooltip>
        <Tooltip title='New "wherein" dependent claim.'>
          <Button style={{margin: 0, padding: 0}} size="small"
                  onClick={(e) => {
                    claim.addChild(EditorState.createEmpty(decorator), 'dep/wi', claim.claimClass, '', false);
                  }}
            
          >+WI</Button>
        </Tooltip>
        <IconButton size='small' 
                    style={{display: 'inlineBlock'}}
                    onClick={() => claim.toggleViewOpen()}>
          {claim.viewOpen ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </span>
    );
  };
  
  const generatePreamble = () => {
    //const spanStyle = !claim.viewOpen ? {maxHeight: '1.4em', overflow: 'hidden'} : {};
    const spanStyle = {maxHeight: '1.3em', overflow: 'hidden'};
    return (
      <div style={styles.claimEditorHeader}>
        {claim.claimType === 'ind' ?
         <span style={spanStyle}>
           {claim.claimNum}. {firstWord()}&nbsp; 
           <ContentEditable
             style={{display: 'inline-block', backgroundColor: 'lightgray'}}
             html={claim.claimClass}
             onChange={(e) => walkTree(claim, (n) => n.setClaimClass(e.target.value))}
           /> {claim.tree.preamble || '...'}
         </span> :
         claim.claimType === 'dep/fc' ?
         <span style={spanStyle}>
            {claim.claimNum}. The {claim.claimClass} of claim {claim.parent.claimNum}, {claim.tree.preamble || '...'}
         </span> :
         claim.claimType === 'dep/wi' ?
         <span style={spanStyle}>
           {claim.claimNum}. The {claim.claimClass} of claim {claim.parent.claimNum},
           wherein the {entityMenu()} {claim.tree.preamble || '...'}
         </span>
         : 'Unknown claim type'
        }
        {headerButtons()}
      </div>);
  };

  const walkTree = (node, callback) => {
    callback(node);
    for (const child of node.children)
      walkTree(child, callback);
  };

  const entityMenu = () => {
    return (
        <select
          value={claim.entityKey || ''}
          onChange={(e) => {
            claim.setEntity(e.target.value);
          }}
        >
          <option value=''>Entity</option>
          {Object.entries(workshop.claimSet.entityMap).map(([k,v], idx) => {
            return <option key={k} value={k}>{v.text}</option>;})}
        </select>
    );
  };
  
  const styler = (block) => {
    if (block.getType() === 'unordered-list-item') {
      return 'comment';
    }
  };

  const customStyles = {
    COMMENT: { color: 'blue' }
  };

  const placeHolder = () => {
    if (claim.claimType === 'ind')
      return 'for baking a cake, the method comprising:\n  measuring flour ...';
    else if (claim.claimType === 'dep/fc')
      return 'further comprising:\n  combining the butter and the sugar ...';
    else
      return 'includes ...';
  };

  return (
    <div  > {/* onClick={focus}>*/}
      {generatePreamble()}
      {claim.viewOpen ?
       <div style={claim.claimType !== 'dep/wi' ? styles.editor : styles.depWiEditor}>
          <Editor
           customStyleMap={customStyles}
           blockStyleFn={styler}
           handleBeforeInput={handleBefore}
           handleKeyCommand={handleKeyCommand}
           keyBindingFn={mapKeyToEditorCommand}
           editorState={claim.editorState}
           onChange={onChange}
           placeholder={placeHolder()}
           //ref={myRef}
           spellCheck={true}
         />
         {filterEntities()}
       </div> : null }
      {claim.viewOpen ?
       <div style={styles.claimEditorFooter}>
       {/*<span>
           Dependents:
           <Tooltip title='New "further comprising" dependent claim.'>
             <Button size="small" variant="outlined"
               onClick={(e) => {
                 claim.addChild(EditorState.createEmpty(decorator), 'dep/fc', claim.claimClass, '', false);
               }}
             >F/C</Button>
           </Tooltip>
           <Tooltip title='New "wherein" dependent claim.'>
             <Button size="small" variant="outlined"
               onClick={(e) => {
                 claim.addChild(EditorState.createEmpty(decorator), 'dep/wi', claim.claimClass, '', false);
               }}
             >W/I</Button>
           </Tooltip>
           </span>*/}
         
       <span style={{display: 'flex', alignItems: 'center'}}>
         <Tooltip title="Show the written description text in the editor">
           <span>
             <Checkbox
               color="primary" size="small"
               checked={claim.showWD}
               onChange={() => toggleComment(claim, claim.claimSet.entityMap)}
             />
             Show WD
           </span>
         </Tooltip>

         <Tooltip title="Generate a claim for this editor">
           <span>
             <Checkbox
               color="primary" size="small"
               checked={claim.makeClaim}
               onChange={() => claim.toggleMakeClaim()}
             />
             Claim
           </span>
         </Tooltip>

         <Tooltip title="Render a drawing for this claim">
         <span>
           <Checkbox
             color="primary" size="small"
             checked={claim.drawFig}
             onChange={() => claim.toggleDrawFig()}
           />
           Draw 
         </span>
         </Tooltip>

         {claim.drawFig && claim.claimType === 'ind' ?
          <span>
             <Switch
               disabled={claim.claimType !== 'ind'}
               color="primary" size="small"
               checked={claim.figType === 'process'}
               onChange={() => {
                 if (claim.figType === 'process')
                   claim.setFigType('apparatus');
                 else
                   claim.setFigType('process');
               }}
             />As {claim.figType}
          </span>
          : null}
         
      <IconButton size='small'
                  disabled={!claim.canMoveLeft()}
                  onClick={() => {parent.moveChildLeft(claim);}}
      >
        <ArrowUpward />
      </IconButton>
      <IconButton size='small'
                  disabled={!claim.canMoveRight()}
                  onClick={() => {parent.moveChildRight(claim);}}>
        <ArrowDownward />
      </IconButton>
      <IconButton style={{width: 20, height: 20}}
                  onClick={() => parent.deleteChild(claim)}
      >
        <Delete />
      </IconButton>
       </span>
       </div>  : null
      }
    </div>
  );
}); 

const ClaimSetEditor = observer((props) => {
  //console.log('CSED constructor', props);
  const [view, setView] = React.useState(0);

  const onReplace = (searchString, replaceString, entityKey) => {
    //console.log('REPLACING', searchString, replaceString);
    // Need to make sure they don't destroy the entity here
    if (replaceString.length >= 1)  {
      workshop.claimSet.globalReplace(searchString, replaceString, entityKey, false);
      workshop.claimSet.updateEntityMap();
    }
  };

  const listEditors = (node) =>  {
    if (node.children.length === 0) return null;
    let priorClosed = false;
    return node.children.map((child, idx) => {
      const shouldRender = child.viewOpen || !priorClosed;
      priorClosed = !child.viewOpen;
      return (
        shouldRender ?
          <div style={styles.claimEditor}>
            <ClaimEditor key={'claim_' + child.claimNum} parent={node} claim={child}/>
            {/*child.viewOpen  ? listEditors(child) : null*/}
            {listEditors(child)}
          </div> : <div style={styles.claimEditorHidden}></div>
      );});
  };
  
  const logState = () => {
    console.log(toJS(workshop));
    console.log(workshop.toHTML());
    workshop.shareWithWord();
  };

  const listEntities = () => {
    // FIXME:  Use an ordered map here!
    //console.log('LISTING ENT');
    let entities = Object.entries(workshop.claimSet.entityMap);
    return (
      <div style={{margin: '0.5em'}}>
        {entities.map(([k,v], idx)=>{
          return (
            <div style={{display: 'flex', alignItems: 'center'}} key={k}>
              <TextField
                inputProps={{style: {fontSize: '0.9em'}}}
                style={{width: '90%', margin: '0.2em'}}
                value={v.text}
                onChange={(e) => {
                  //updateEntity(k, e.target.value);
                  onReplace(v.text, e.target.value, k);
                  workshop.claimSet.updateEntityMap();
                }}
              />
              <IconButton size='small' onClick={() => {
                workshop.claimSet.deleteEntity(v.text, k);
              }}>
                <Delete /></IconButton>{/*({k.slice(-4)})*/}
            </div>);
        })}
      </div>
    );
  }; 

  const TabButton = (index, label, tip, Icon, cb) => {
    const ButtonComponent = Icon ? IconButton : Button;
    //const theVariant = Icon ? '' : index === view ? 'outlined' : 'text';
    return (
      <div style={index === view ? {borderBottom: '4px solid gray'} : {}}>
      <ButtonComponent
        style={Icon ? {} : {width: "20%"}}
        onClick={() => {
          setView(index);
          console.log('TAB', cb);
          if (cb) cb(index);
        }} >
        <Tooltip title={tip}>
          {Icon ? <Icon /> : <span>{label}</span>}
        </Tooltip>
      </ButtonComponent>
      </div>
    );
  };

  const predictions = [
    ['red', 'Very likely ineligible'],
    ['orange', 'Probably ineligible'],
    ['yellow', 'Caution'],
    ['greenyellow', 'Probably eligible'],
    ['limegreen', 'Very likely eligible'],
  ];

  const showSettings = () => {
    return (
      <div style={{marginTop: '1.0em'}}>

        <div style={{display: 'flex', alignItems: 'baseline', marginBottom: "0em"}}>
          Base Figure No. 
          <TextField
            style={{width: "3em"}} 
            value={workshop.claimSet.figBase}
            onChange={(e) => {
              workshop.claimSet.setFigBase(e.target.value);
              workshop.claimSet.numberClaims();
            }}
          />
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
          {workshop.claimSet.doAliceScoring ? "AliceScores enabled" : "AliceScores disabled"}
          <Switch checked={workshop.claimSet.doAliceScoring} color="primary"
                  onChange={() => workshop.claimSet.setDoAliceScoring(!workshop.claimSet.doAliceScoring)}/>
        </div>
        <div>
          <Button
            variant='outlined'
            disabled={!workshop.user || !workshop.user.key}
            onClick={() => workshop.shareWithWord()}
            >
            Save to Word
          </Button>
          <Typography style={{paddingLeft: '1em'}} variant="body2" display="block" gutterBottom={true}>
            To inject generated content into a Word document, you will need to install our Word Add-In,
            and provide your access key.
          </Typography>
        </div>

        <Typography variant="h6">Status</Typography>
        <Typography variant="body1" display="block" gutterBottom={true}>
          Server status ({JSON.stringify(socketURL)}):
          {workshop.connected ? <CheckCircle fontSize='small' style={{color: 'green'}} /> :
           <Error fontSize='small' style={{color: 'red'}} />}
        </Typography>
        <Typography variant="body1" display="block" gutterBottom={true}>
          User: {JSON.stringify(workshop.user, null, 2)}
        </Typography>
        <Typography variant="body1" display="block" gutterBottom={true}>
          Google Acct: {JSON.stringify(workshop.getGoogleUser(), null, 2)}
        </Typography>
        <Typography variant="body1" display="block" gutterBottom={true}>
          Google Drive Doc: {JSON.stringify(workshop.doc, null, 2)}
        </Typography>

      </div>
    );
  };

  const renderClaims = () => {
    const claim = workshop.claimSet.children[0];
    if (!claim) return null;
    const res = claim.aliceScore;
    //console.log('RESULT', toJS(workshop.children[0]));
    const score = res ? Math.floor(res.score * 100) : 0;
    const pred = predictions[Math.floor(score/20)];
    const colorScore = <span style={{backgroundColor: pred[0]}}>{score}</span>;
    return (
      <div style={{fontSize: '0.9em'}}>
        <div dangerouslySetInnerHTML=
               {{__html: claimTemplate({claimSet: workshop.claimSet,
                                        heading: 'Claims'})}}></div>
        {res && workshop.claimSet.doAliceScoring ?
         <div style={{border: '1px solid gray', margin: '1.0em', padding: '0.3em',
                      display: 'flex', justifyContent: 'space-between'}}>
           <div>Alice Score: {colorScore}
             <div style={{fontSize: '0.8em'}}>{pred[1]}<br />(Claim 1)</div>
           </div>
           <div style={{display: 'flex', width: "60%", alignItems: 'center'}}>
             <div>Highlight Threshold:</div>
             <Slider value={claim.hlThreshold * 100} max={200}
                     onChange={(e, newValue) => {
                       //console.log(newValue);
                       claim.setHlThreshold(newValue/100);
                     }}/>
           </div>
         </div> : null}
      </div>
    );
  };

  //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
  //console.log(JSON.stringify(model, (key,value) => key in jsonMap ? jsonMap[key] : value, 2));
  //console.log(JSON.stringify(model.dumpClaims(), null, 2));
  // was model.save() below
  //console.log('Rendering');
  return (
    <div style={{margin: '0.2em'}}>
      <div style={{border: '1px solid black', margin: '0.2em',
                   display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <Tooltip title={`Client version: ${window.VERSION}`}>
          <img src={logo} style={{height: '1.5em', marginLeft: '0.5em'}}
               alt="Lawtomata Logo"/>
          </Tooltip>
          <FileMenu workshop={workshop} />
          <Tooltip title="Select claim text and click to create a new entity">
            <Button
              onClick={() => { workshop.claimSet.addEntityAtSelection(); }}
            >
              Make Entity
            </Button>
          </Tooltip>
          <Button 
            onClick={() => {
              workshop.addNewClaim('ind', 'method');
            }}
          >
            New Ind. Claim
          </Button>
          <Button onClick={logState} >
            Debug
          </Button>
          <Typography variant='body2'>
            Filename: {workshop.doc ? workshop.doc.name : '[none]'}
            {workshop.claimSet.dirty ? '*' : null}
          </Typography>
        </div>

        <div style={{marginRight: '0.5em'}}>
          <span>
            {workshop.updateAvailable &&
             <Button
               style={{color: 'red'}}
               onClick={() => {
                 workshop.setUpdateAvailable(false);
                 localStorage.clear();
                 window.location.reload();
               }}>
               Update Available
             </Button> }
            
            <Typography variant="body2">
              Google Drive:
            {workshop.googleUser ? 
             <span>
               {workshop.googleUser.getEmail()}
               <IconButton size='small' style={{display: 'inlineBlock'}}
                             onClick={() => signOut(workshop)}>
                   <ExitToApp /> 
                 </IconButton>
               </span>
               : 'disconnected'} 
            </Typography>
          </span>
        </div>
      </div>

      {/*picking ? showPicker() : null*/}
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div style={styles.claimEditors}>
          {listEditors(workshop.claimSet, workshop.claimSet)}
        </div>

        <div style={styles.tabsContainer}>
          <div style={{display: 'flex', justifyContent: 'space-around'}}>
            {TabButton(0, "Entities", "Show list of entities", BubbleChart)}
            {TabButton(1, "Claims", "Show generated claims", Gavel, (index) => workshop.getAliceScores(true))}
            {TabButton(2, "Figs.", "Show generated drawings", Create)}
            {TabButton(3, "Text", "Show text corresponding to drawings", Subject)}
            {TabButton(4, "Settings", "Status and settings", Settings)}
          </div>
          {view === 0 &&
           <div>{listEntities()}</div> }
          {view === 1 && renderClaims() }
          {view === 2 &&
           <div>
             <div style={{fontSize: '0.9em'}}
                  dangerouslySetInnerHTML={{__html: drawingTemplate({claimSet: workshop.claimSet,
                                                                     heading: 'Drawings'})}}>
             </div>
           </div> }
          {view === 3 && 
           <div style={{fontSize: '0.9em'}}
                dangerouslySetInnerHTML={{__html: wdTemplate({claimSet: workshop.claimSet,
                                                              heading: 'Written Description'})}}>
           </div> }
          {view === 4 &&
           <div>
             {showSettings()}
           </div> }
        </div>
      </div>
    </div>
  );
});


const App = observer(() => {
  const { key } = useParams();
  const skipLogin = false;
  console.log('Key', key);
  return (
    <MuiThemeProvider theme={theme}>
      {!workshop ? null :
       skipLogin ||  workshop.loginStatus === 'LOGIN_OK' ?
       <ClaimSetEditor content={rawContent}/> :
       <Login model={workshop} theKey={key}/>}
    </MuiThemeProvider>
  );
  
});


export default App;


